import { makeStringToUtf8Bytes } from '@/utils/makeStringToUtf8Bytes';

export function getCustomKeyGenerator(key: string, salt: string) {
  if (salt == null || salt == '' || typeof salt === 'undefined') {
    return key;
  }

  const buffer = new ArrayBuffer(32);
  const keyBytes = new Uint8Array(buffer);

  const bytes = makeStringToUtf8Bytes(key);

  let len = bytes.length;
  if (len > keyBytes.length) {
    len = keyBytes.length;
  }

  // keyBytes 에 bytes 배열을 복사
  for (let i = 0; i < len; i++) {
    keyBytes[i] = bytes[i];
  }

  // salt 값을 바이트 배열로 변환 - 길이제한은 없으나 32자리까지 사용
  const saltBytes = makeStringToUtf8Bytes(salt);

  for (let i = 0; i < keyBytes.length; i++) {
    // key 와 salt(salt 값이 키바이트 길이보다 잛은경우 나머지 값) 자리마다 바이트를 And 연산한다
    let b: any = new Uint8Array(buffer);
    b = (keyBytes[i] & saltBytes[i % saltBytes.length]) % 0x126;

    // ASCII 코드 중 0x32 ~ 0x126까지 출력가능 문자 (0x32는 스페이스라 제외))
    if (b < 0x33) {
      keyBytes[i] = b + 0x33;
    } else {
      keyBytes[i] = b;
    }
  }

  let customKey = '';
  keyBytes.forEach(function (value) {
    // ASCII 코드를 문자열로 변환한다
    customKey += String.fromCharCode(value);
  });

  return customKey;
}
